export default "__VITE_ASSET__DIFISa9H__"